<div class="doc">
  <div class="col-sm-12 header">
    <h2 class="col-sm-6" style="padding:0px; margin: 0;">
      <span> Liste des documents </span>
    </h2>
    <button type="button" class="fermer pull-right" aria-label="Close" (click)="common.closeModal();">
      <i class="fa fa-times" style="color: #376194;" aria-hidden="true"></i>
    </button>
  </div>
  <div class="col-sm-12 tab">
    <ngx-datatable [ngStyle]="{ 'height': data && data.length > 8 ? '100%' : 'auto' }" class="material document"
      [rows]="data || []" [columnMode]="'force'" [headerHeight]="30" [footerHeight]="0" [rowHeight]="42"
      [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
      [loadingIndicator]="loadingIndicator" (activate)="onActivate($event)">
      <ngx-datatable-column name="Description">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase"> Description </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div *ngIf="row.id">
            {{value}}
          </div>
          <div *ngIf="!row.id">
            <input type="text" class="form-control" [(ngModel)]="row.description">
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column prop="oTypeDocAssocie.libelle" *ngIf="common.showTypeFile">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase"> Type du fichier </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div *ngIf="row.id" class="col-m-12">
            {{value   || '' }}
          </div>
          <div *ngIf="!row.id"   class="col-sm-12">
            <app-autocomplete-material [placeholder]="''" [isCombo]="true"
            (selectfunction)="row.oTypeDocAssocie = $event"
             id="modedepaie" 
            [container]="true" [disablefocus]="true"
            [highlight]="true"  [dropdownclass]="'maxZindex'"
            [defaultselected]="row.oTypeDocAssocie" [results]="listeTypeDoc" [label]="''"
            [defaultsearch]="row.oTypeDocAssocie ? (row.oTypeDocAssocie.libelle || row.oTypeDocAssocie.libelleObjetEntite) : ''">
          </app-autocomplete-material>

          </div>
        </ng-template>
      </ngx-datatable-column>


      <ngx-datatable-column name="NomFichier" prop="nomFichier">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase"> Fichier </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div *ngIf="row.id">
            {{value}}
          </div>
          <div *ngIf="!row.id">
            <input class="hide" id="input-file-id{{rowIndex}}" (change)="getNameFile($event, row)" multiple type="file"
              accept="{{ common.extFichierImgEtTexte }}" />
            <div class="input-group">
              <input type="text" class="form-control" [(ngModel)]="row.nomFichier" readonly>
              <label class="input-group-addon" for="input-file-id{{rowIndex}}"><i class="fa fa-upload"></i> Parcourir
              </label>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngIf="!common.isHisto" [width]="70" [sortable]="false" [canAutoResize]="false"
        [draggable]="false" [resizeable]="false">
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
          <button class="btn-detail" (click)="deleteLigne(row)">
            <i class="fa fa-trash"></i>
          </button>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
    <div class="col-sm-6" style="padding: 0; z-index: 10;">
      <button class="btn-add" (click)="addLigne()" *ngIf="!common.isHisto">
        <i class="fa fa-plus"></i>
      </button>
      <span *ngIf="!common.isHisto"> Ajouter un document </span>
    </div>
  </div>



  <div class="foot" style="margin-top: 15px;">
    <div class="col-sm-6" style="padding: 0;">
    </div>
    <div class="text-right col-sm-6" style="padding: 0;">
      <!--button type="button" class=" btn-valider" (click)="valide()"> Valider </button-->
      <button *ngIf="common.afficherBtnDownloadAll" type="button" style="width: 184px; margin-right: 5px"
        class="btn-close btn-validerMdl" (click)="downloadAll()"> Tout télécharger  </button>
      <button type="button" class=" btn-close btn-validerMdl" (click)="valide()"> Valider </button>
    </div>

  </div>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer </button>
    </div>
  </div>
</ng-template>

<ng-template #modalPdf>
  <div class="col-sm-12 header text-right" style="    padding: 5px 15px 0px;">
    <!-- <h2 class="col-sm-6" style="padding:0px; margin: 0;">
      <span> Liste des documents </span>
    </h2> -->
    <button type="button" class=" btn-close btn-validerMdl" (click)="common.closeModal();"> Fermer </button>
  </div>
  <div class="modal-body showImage" style="height: auto; padding: 5px 15px 10px;">
    <div class="col-sm-12 p-0">
      <div class="col-sm-12" style="border-left: 1px solid #e7e7e7;">
        <div class="row parentpdf">
          <div class="pdf col-sm-12 p-0">
            <div id="my-container" class=" pdfobject-container">
              <iframe id="BlockIframe" [src]="modalImageSrc | safe" width="100%" height="100%" style="overflow: auto;">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</ng-template>


<div class="spinner" *ngIf="showSpinner">
  <div class="sk-fading-circle">
    <div class="sk-circle1 sk-circle"></div>
    <div class="sk-circle2 sk-circle"></div>
    <div class="sk-circle3 sk-circle"></div>
    <div class="sk-circle4 sk-circle"></div>
    <div class="sk-circle5 sk-circle"></div>
    <div class="sk-circle6 sk-circle"></div>
    <div class="sk-circle7 sk-circle"></div>
    <div class="sk-circle8 sk-circle"></div>
    <div class="sk-circle9 sk-circle"></div>
    <div class="sk-circle10 sk-circle"></div>
    <div class="sk-circle11 sk-circle"></div>
    <div class="sk-circle12 sk-circle"></div>
  </div>
</div>